<template>
  <div class="col-md-4 pdf-extraction">
    <div class="btn-toolbar">
      <div class="w-100">
        <a
          :class="['btn btn-inverse', isImageSourceEmpty ? 'disabled' : '']"
          title="Save extraction"
          @click="startSaveExtractions"
        >
          <font-awesome-icon :icon="['fas', 'save']" class="icon" /><span class="btn-text">Save</span>
        </a>
        <a :class="['btn btn-inverse']" title="Save copy" @click="startSaveCopy">
          <font-awesome-icon :icon="['fas', 'save']" class="icon" /><span class="btn-text"
            >Save Copy</span
          >
        </a>
        <a
          :class="['btn btn-inverse', isImageSourceEmpty ? 'disabled' : '']"
          title="Preview extraction"
          @click="handlePreview"
        >
          <font-awesome-icon :icon="['fas', 'eye']" class="icon" /><span class="btn-text"
            >Preview</span
          >
        </a>
        <a
          :class="['btn btn-inverse float-end', isImageSourceEmpty ? 'disabled' : '']"
          title="Delete extraction"
          @click="deleteExtraction"
        >
          <font-awesome-icon :icon="['fas', 'trash']" class="icon" /><span class="btn-text"
            >Delete</span
          >
        </a>
      </div>
      <save-modal-inputs
        v-if="showSaveModalInputs"
        @close="showSaveModalInputs = false"
        @continueToSave="continueToSave"
      ></save-modal-inputs>
    </div>
    <div class="extraction">
      <ul v-if="imageSources.length > 0" class="extraction__list">
        <!-- render extracted PDFs -->
        <li
          v-for="(source, index) in imageSources"
          :key="index"
          class="e__list__item"
          :class="{ highlight: source.isHighlighted }"
        >
          <img
            v-if="source.src"
            :src="source.src"
            :alt="index"
            class="e__list__img"
            @click.prevent.stop="highlightExtraction(index)"
          />
          <p class="e__list__desp">
            E. {{ index + 1 }} | from Page
            <span v-for="(pageNumber, index) in source.pageNumbers" :key="index">
              {{ pageNumber }}.
            </span>
          </p>
        </li>
      </ul>
      <div v-else class="void-filler-extraction">
        <h1 class="filler-header"><font-awesome-icon :icon="['fas', 'search-plus']" /></h1>
        No extraction to display yet.<br />
        Please click on the <font-awesome-icon :icon="['fas', 'crop']" class="icon" /> button on the
        top right corner of the PDF viewer to start selecting portions of the PDF to make
        your report.
      </div>
    </div>

    <!-- save extraction -->
    <pdf-extraction-save-modal
      v-if="showSaveModal"
      @close="showSaveModal = false"
      :extractionInfos="getExtractionInfosForSaving"
      :dob="dob"
      :reportDate="reportDate"
      :pdfId="pdfId"
    ></pdf-extraction-save-modal>

    <!-- preview extraction -->
    <!-- <preview-modal v-if="showPreviewModal" @close="showPreviewModal=false" :imageSources="imageSources"></preview-modal> -->
    <extraction-preview
      v-if="showPreviewModal"
      @close="showPreviewModal = false"
      :preview="preview"
    ></extraction-preview>

    <!-- ask where to insert -->
    <pdf-modal-insert
      v-if="showInsertModal"
      @close="processInsertSelection"
      :indexOfHighlighted="indexOfHighlighted"
    ></pdf-modal-insert>
  </div>
</template>

<script>
import EventBus from "../../../event-bus";
import PreviewModal from "./PdfExtractionPreviewModal";
import PdfModalInsert from "./PdfExtractionInsertModal";
import PdfExtractionSaveModal from "./PdfExtractionSaveModal";
import { HighlightRectangleCommand } from "../../../constants/pdf-commands";
import { mapGetters } from "vuex";
import { getPreview } from "@/api/pdfApi";

import SaveModalInputs from "./save-modal/SaveModalInputs";

export default {
  name: "pdf-extraction",
  data() {
    return {
      saveCopy: false,
      imageSources: [],
      // isImageSourceEmpty: true,
      showInsertModal: false,
      showSaveModal: false,
      showPreviewModal: false,
      showSaveModalInputs: false,
      tempImageSource: {},
      indexOfHighlighted: 0, // set to currently highlighted element index
      preview: null,
      extractionInfos: null, // list of extractions, used to get preview
      reportDate: "",
      dob: "",
    };
  },
  components: {
    "pdf-modal-insert": PdfModalInsert,
    // 'preview-modal': PreviewModal,
    "extraction-preview": PreviewModal,
    "pdf-extraction-save-modal": PdfExtractionSaveModal,
    "save-modal-inputs": SaveModalInputs,
  },
  mounted() {
    EventBus.on("addToExtractedList", ({ response, requestParams } = {}) => {
      if (response) {
        this.showInsertSelection(response, requestParams);
      }
    });

    EventBus.on("clearUserInteraction", () => {
      this.deleteAllExtraction();
    });
  },
  beforeDestroy() {
    EventBus.off("clearUserInteraction");
    EventBus.off("addToExtractedList");
  },
  props: {
    // The PDF's 32-hex uid, or a numeric id from before the uid.
    pdfId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    /*
      ...mapGetters('login/pdf', {
        pdfId: 'getPdfId'
      }),*/
    getExtractionInfosForSaving: function () {
      if (this.saveCopy) return [];
      else return this.getExtractionInfos;
    },
    getExtractionInfos: function () {
      let extractionInfos = [];
      this.imageSources.forEach((imageSource) => {
        extractionInfos.push(imageSource.extractionInfo);
      });
      return extractionInfos;
    },
    isImageSourceEmpty: function () {
      return this.imageSources.length < 1;
    },
  },
  methods: {
    startSaveExtractions() {
      this.saveCopy = false;
      this.showSaveModalInputs = true;
    },
    startSaveCopy() {
      this.saveCopy = true;
      this.showSaveModalInputs = true;
    },
    continueToSave(reportDate, dob) {
      this.reportDate = reportDate;
      this.dob = dob;
      this.showSaveModal = true;
    },

    deleteAllExtraction() {
      this.imageSources = [];
    },

    /*
     * Delete highlighted thumbnail
     * If no thumbnail is selected, delete all
     */
    deleteExtraction() {
      let lengthBeforeFilter = this.imageSources.length;
      this.imageSources = this.imageSources.filter((source) => {
        return source.isHighlighted === false;
      });

      // if no thumbnail is selected, delete all
      if (lengthBeforeFilter === this.imageSources.length) {
        this.$swal({
          title: "Delete extraction",
          text: "Are you sure  you want to delete all the extractions?",
          type: "warning",
          showCancelButton: true,
          cancelButtonColor: "#3085d6",
          confirmButtonColor: "#d33",
          confirmButtonText: "Yes, delete",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            this.deleteAllExtraction();
          }
        });
      }
    },

    /* Highlight selected thumbnail */
    highlightExtraction(index) {
      this.imageSources = this.imageSources.map((imageSource) => {
        imageSource.isHighlighted = false;
        return imageSource;
      });
      this.imageSources[index].isHighlighted = true;
      this.indexOfHighlighted = index + 1;

      EventBus.emit(HighlightRectangleCommand, this.imageSources[index].dimension);
    },

    showInsertSelection(imageSrc, extractionInfo) {
      // show modal, ask where to insert
      this.showInsertModal = true;

      // not add to the extraction array til user selects where to insert
      let imageInfo = this.getImageInfo(extractionInfo.source.selections[0]);
      // clj(extractionInfo);
      this.tempImageSource = {
        src: imageSrc,
        isHighlighted: false,
        pageNumbers: imageInfo.pageNumbers,
        dimension: imageInfo.dimension,
        extractionInfo: extractionInfo,
      };
    },

    /* Process user selection from the modal */
    processInsertSelection(selection, whereToInsert) {
      switch (selection) {
        case "appendToLastPage":
          this.imageSources.push(this.tempImageSource);
          this.showInsertModal = false;
          break;
        case "insertBeforeFirstPage":
          this.imageSources.unshift(this.tempImageSource);
          this.showInsertModal = false;
          break;
        case "insertTo":
          // only close the modal when a number is entered
          if (whereToInsert !== null) {
            this.imageSources.splice(whereToInsert, 0, this.tempImageSource);
            this.showInsertModal = false;
          }
          break;
      }
      this.tempImageSource = null;
    },

    getImageInfo(selection) {
      let info = {};

      // get page numbers
      info["pageNumbers"] = [];
      selection.intersections.forEach((s) => info["pageNumbers"].push(s.pageNumber));

      // get image dimension
      info["dimension"] = selection.selection;
      return info;
    },

    handlePreview() {
      let loader = this.$loading.show();
      // if list of extractions didnt change, do not send request again
      let newExtractionInfos = this.getExtractionInfos;
      if (this.extractionInfos !== newExtractionInfos) {
        this.extractionInfos = newExtractionInfos;
        getPreview({ id: this.pdfId, extractions: this.extractionInfos })
          .then((response) => {
            // update preview
            this.preview = response.preview;
            // show
            this.showPreviewModal = true;
          })
          .catch((err) => {
            console.trace(err);
            alert(err);
          })
          .finally(() => {
            loader.hide();
            loader = null;
          });
      } else {
        // show
        this.showPreviewModal = true;
        loader.hide();
        loader = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.highlight {
  background-color: hsla(0, 0%, 100%, 0.3);
  background-image: linear-gradient(hsla(0, 0%, 100%, 0.05), hsla(0, 0%, 100%, 0));
  background-clip: padding-box;
  box-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.05) inset, 0 0 1px hsla(0, 0%, 100%, 0.1) inset,
    0 0 1px hsla(0, 0%, 0%, 0.2);
  color: hsla(0, 0%, 100%, 1);
}

.btn-toolbar {
  /*height: 32px;*/
  padding-right: 10px;
  background-image: url("../../../assets/images/texture.png"),
    linear-gradient(hsla(0, 0%, 32%, 0.99), hsla(0, 0%, 27%, 0.95));
  position: relative;
  .btn {
    &:hover {
      border: 1px solid lighten(#000, 20%);
      background-color: lighten(#000, 20%);
    }
  }
  .icon {
    color: #fff;
  }
}
.extraction {
  height: 65vh;
  overflow: scroll;
  background-color: hsla(0, 0%, 0%, 0.7);
}

.extraction__list {
  list-style-type: none;
  margin: 0;
  padding: 20px 0;
}

.e__list__item {
  text-align: center;
  margin: 0 auto;
  margin-bottom: 15px;
  padding-top: 5px;
  border-radius: 3px;
  max-width: 14rem;

  .e__list__img {
    max-width: 13rem;
    height: auto;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3);
    background-color: #ffffff;
    background-clip: content-box;
    opacity: 1;
    border: 1px solid transparent;
    /*padding: 0.5rem;*/
  }

  .e__list__desp {
    color: #ffffff;
    font-size: 12px;
  }
}

.void-filler-extraction {
  color: gray;
  font-size: 1rem;
  margin: 1rem;
  text-align: center;

  .filler-header {
    font-size: 2.5rem;
    text-align: center;
  }
}

.btn-text {
  color: #fff;
  display: block;
  font-size: 0.75em;
}
</style>
